// extracted by mini-css-extract-plugin
export default {"duo":"duo___ze5Ar","content_2_1":"content_2_1___gCsgx","content1":"content1___1rwyJ","content2":"content2___1-vAt"};